module.exports = __webpack_public_path__ + "assets/word_annual_agreement_default.220cdc53.svg";